// Arquivo gerado por scripts/generate-build-info.js. Nao edite manualmente.
export const BUILD_INFO = {
  "version": "10.0.1",
  "revision": "3350b95",
  "builtAt": "2026-10-22T22:37:50.208Z",
  "buildId": "10.0.1-3350b95-2026-10-22T22:37:50.208Z"
};
